import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, inject, Output, signal } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from '../../../core/common/app-constants';


@Component({
selector: 'app-header',
standalone: true,
imports: [CommonModule],
templateUrl: './header.component.html',
styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  private router = inject(Router);

  // // Usamos Signals para una reactividad moderna (Angular 17+)
  // sistemaActivo = signal('facturacion'); 
  // @Output() solicitarDemoEvt = new EventEmitter<void>();

//   // Navegación suave a las secciones por ID
//   scrollTo(sectionId: string) {
//     const element = document.getElementById(sectionId);
//     if (element) {
//       element.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     }
//   }

//   onSolicitarDemo() {
//     this.solicitarDemoEvt.emit();
//   }

//  isScrolled = false;

//   @HostListener('window:scroll', [])
//   onWindowScroll() {
//     this.isScrolled = window.scrollY > 30;
//   }

  // ingresar(){
  //   window.open('http://pwa.centrixperu.com/#/auth', '_blank');
  // }

  // contact(){
  //   this.router.navigate(["/contact"]);
  // }

  // price(){
  //   this.router.navigate(["/price"]);
  // }

  // solicitarDemo() {
  //   const msg = `Hola, solicito demo del sistema: ${this.sistemaActivo()}`;
  //   window.open(`https://wa.me/51966637291?text=${encodeURI(msg)}`, '_blank');
  // }
  ////////////////////////////

  // // Estado reactivo usando Signals
  // menuOpen = signal(false);

  // // Datos de navegación
  // navLinks = [
  //   { href: '#inicio', label: 'Inicio' },
  //   { href: '#servicios', label: 'Servicios' },
  //   { href: '#precios', label: 'Precios' },
  //   { href: '#contacto', label: 'Contacto' }
  // ];

  // toggleMenu() {
  //   this.menuOpen.update(prev => !prev);
  // }



  // isScrolled = signal(false);
  // menuOpen = signal(false);

  // navLinks = [
  //   { label: 'Inicio', href: '#inicio' },
  //   { label: 'Servicios', href: '#servicios' },
  //   { label: 'Contacto', href: '#contacto' }
  // ];

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   this.isScrolled.set(window.scrollY > 50);
  // }

  // toggleMenu() {
  //   this.menuOpen.update(v => !v);
  // }

  isScrolled = signal(false);

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.isScrolled.set(window.scrollY > 50);
  }

  inicio(){
    this.router.navigate([AppConstants.routes.HOME]);
  }

  servicios(){
    this.router.navigate([AppConstants.routes.SERVICIOS]);
  }

  contacto(){
    this.router.navigate([AppConstants.routes.CONTACT]);
  }

  cotizar(){
    this.router.navigate([AppConstants.routes.SYSTEM_FACTURACION]);
  }

}
